module.exports = __webpack_public_path__ + "static/media/AvenirNextLTPro-Regular.67016125.otf";